import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.less']
})
export class MailComponent implements OnInit {
  getFullYear: number = new Date().getFullYear();
  constructor() { }

  ngOnInit() {
  }

}
